import type { ReactNode } from "react";

import CS from "metabase/css/core/index.css";
import type { FlexProps, GroupProps } from "metabase/ui";
import { Flex, Group, Icon } from "metabase/ui";
import type { ColorName } from "metabase/ui/colors/types";
import type { IconName } from "metabase-types/api";

interface BaseBannerProps extends FlexProps {
  icon?: IconName;
  iconColor?: ColorName;
  body: ReactNode;
  contentGroupProps?: GroupProps;
}

export type BannerProps =
  | (BaseBannerProps & { closable: true; onClose: () => void })
  | (BaseBannerProps & { closable?: false; onClose?: never });

export const Banner = ({
  icon,
  iconColor,
  body,
  closable,
  onClose,
  bg,
  contentGroupProps,
  ...flexProps
}: BannerProps) => {
  return (
    <Flex
      data-testid="app-banner"
      align="center"
      bg={bg || "background-tertiary"}
      py="sm"
      justify="space-between"
      pl="1.325rem"
      pr="md"
      {...flexProps}
    >
      <Group gap="xs" {...contentGroupProps}>
        {icon && <Icon name={icon} w={36} c={iconColor} />}
        {body}
      </Group>
      {closable && (
        <Icon
          className={CS.cursorPointer}
          name="close"
          onClick={onClose}
          w={36}
          c={iconColor}
        />
      )}
    </Flex>
  );
};
